module.exports = __webpack_public_path__ + "static/media/shapes.3344b948.svg";